export default {
  lang: 'zh_cn',
  uploadImagesLocally: '本地上传图片',
  uploadVideosLocally: '本地上传视频',
  uploadSeamlessImages: '上传无缝隙图片',
  batchSizeModification: '批量修改尺寸',
  width: '宽度',
  height: '高度',
  exclusiveRowForASingleImage: '单张图片独占一行',
  pictureSettings: '图片设置',
  cancel: '取消',
  ok: '确定',
  theImageFailedToLoad: '图片加载失败',
  insertImageThroughURL: '通过URL插入图像',
  picturePath: '图片路径',
  thePathCannotBeEmpty: '路径不能为空',
  pleaseEnter: '请输入',
  pictureDescription: '图片描述',
  imageSize: '图片尺寸',
  imgSize: '宽高',
  imgTitle: '描述',
  imgStyle: '样式',
  noStyle: '无样式',
  imgStroke: '图片描边',
  imgShadow: '图片阴影',
  zh_cn: {
    uploadImagesLocally: '本地上传图片',
    uploadVideosLocally: '本地上传视频',
    uploadSeamlessImages: '上传无缝隙图片',
    batchSizeModification: '批量修改尺寸',
    width: '宽度',
    height: '高度',
    exclusiveRowForASingleImage: '单张图片独占一行',
    pictureSettings: '图片设置',
    cancel: '取消',
    ok: '确定',
    theImageFailedToLoad: '图片加载失败',
    insertImageThroughURL: '通过URL插入图像',
    picturePath: '图片路径',
    thePathCannotBeEmpty: '路径不能为空',
    pleaseEnter: '请输入',
    pictureDescription: '图片描述',
    imageSize: '图片尺寸',
    imgSize: '宽高',
    imgTitle: '描述',
    imgStyle: '样式',
    noStyle: '无样式',
    imgStroke: '图片描边',
    imgShadow: '图片阴影'
  },
  en_us: {
    uploadImagesLocally: 'Upload images locally',
    uploadSeamlessImages: 'Upload seamless images',
    batchSizeModification: 'Batch size modification',
    width: 'Width',
    height: 'Height',
    exclusiveRowForASingleImage: 'Exclusive row for a single image',
    pictureSettings: 'Picture settings',
    cancel: 'Cancel',
    ok: 'Ok',
    theImageFailedToLoad: 'The image failed to load',
    insertImageThroughURL: 'Insert image through URL',
    picturePath: 'Picture path',
    thePathCannotBeEmpty: 'The path cannot be empty',
    pleaseEnter: 'Please enter',
    pictureDescription: 'Picture description',
    imageSize: 'Image size',
    imgSize: 'Size',
    imgTitle: 'Caption',
    imgStyle: 'Style',
    noStyle: "No Style",
    imgStroke: "Stroke",
    imgShadow: "Shadow"
  },
  zh_tw: {
    uploadImagesLocally: '本地上傳圖片',
    uploadVideosLocally: '本地上傳視頻',
    uploadSeamlessImages: '上傳無縫隙圖片',
    batchSizeModification: '批量修改尺寸',
    width: '寬度',
    height: '高度',
    exclusiveRowForASingleImage: '單張圖片獨佔一行',
    pictureSettings: '圖片設置',
    cancel: '取消',
    ok: '確定',
    theImageFailedToLoad: '圖片載入失敗',
    insertImageThroughURL: '通過URL插入圖像',
    picturePath: '圖片路徑',
    thePathCannotBeEmpty: '路徑不能為空',
    pleaseEnter: '請輸入',
    pictureDescription: '圖片描述',
    imageSize: '圖片尺寸',
    imgSize: "寬高",
    imgTitle: "描述",
    imgStyle: "樣式",
    noStyle: "無樣式",
    imgStroke: "描邊",
    imgShadow: "陰影"
  },
  vi_vn: {
    uploadImagesLocally: 'Tải lên ảnh địa phương',
    uploadVideosLocally: 'Tải lên video địa phương',
    uploadSeamlessImages: 'Tải lên hình ảnh không có kẽ hở',
    batchSizeModification: 'Sửa đổi kích thước hàng loạt',
    width: 'Chiều rộng',
    height: 'Chiều cao',
    exclusiveRowForASingleImage: 'Ảnh độc quyền One Line',
    pictureSettings: 'Thiết lập ảnh',
    cancel: 'Hủy',
    ok: 'Bạn có chắc không',
    theImageFailedToLoad: 'Hình ảnh không tải được',
    insertImageThroughURL: 'Chèn hình ảnh qua URL',
    picturePath: 'Đường dẫn hình ảnh',
    thePathCannotBeEmpty: 'Đường dẫn không thể trống',
    pleaseEnter: 'Vui lòng nhập',
    pictureDescription: 'Mô tả hình ảnh',
    imageSize: 'Kích thước hình ảnh',
    imgSize: "Kích thước",
    imgTitle: "Mô tả",
    imgStyle: "Kiểu dáng",
    noStyle: "Không có kiểu",
    imgStroke: "Viền",
    imgShadow: "Bóng"
  },
  id_id: {
    uploadImagesLocally: 'Menguasai gambar lokal',
    uploadVideosLocally: 'Naik Video Lokal',
    uploadSeamlessImages: 'Memuat naik gambar tanpa senyap',
    batchSizeModification: 'Modifikasi ukuran seri',
    width: 'lebar',
    height: 'tinggi',
    exclusiveRowForASingleImage: 'Baris eksklusif untuk gambar tunggal',
    pictureSettings: 'Pengaturan gambar',
    cancel: 'Membatalkan',
    ok: 'Kamu yakin',
    theImageFailedToLoad: 'Gambar gagal dimuat',
    insertImageThroughURL: 'Menyisipkan gambar melalui URL',
    picturePath: 'Jalur gambar',
    thePathCannotBeEmpty: 'Jalan tidak boleh kosong',
    pleaseEnter: 'Silakan masukkan',
    pictureDescription: 'Deskripsi gambar',
    imageSize: 'Ukuran gambar',
    imgSize: "ukuran",
    imgTitle: "keterangan",
    imgStyle: "gaya",
    noStyle: "Tidak ada gaya",
    imgStroke: "perbatasan",
    imgShadow: "bayangayinyi"
  }
}
